export default __webpack_public_path__ + "static/media/icons8-success.b834b71c.svg";